import { render, staticRenderFns } from "./diatance.vue?vue&type=template&id=2e8cae08&scoped=true&"
import script from "./diatance.vue?vue&type=script&lang=ts&"
export * from "./diatance.vue?vue&type=script&lang=ts&"
import style0 from "./diatance.vue?vue&type=style&index=0&id=2e8cae08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8cae08",
  null
  
)

export default component.exports